<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import {
  getPartnersId as fetchData,
  postPartners as createData,
  putPartnersId as updateData,
} from "@/api/partners";
import { getSegments } from "@/api/segments";
import defaultScheme from "@/api/schemes/partners";

const updateScheme = async (scheme) => {
  try {
    const { properties = {} } = scheme;
    const { segment_id } = properties;
    const data = await getSegments();
    segment_id.params = { key: "id", label: "name" };
    segment_id.items = data;
    return scheme;
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        createData,
        updateData,
        updateScheme,
      },
    };
  },
};
</script>
